
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/probabilistic-idr/gcs",
      function () {
        return require("private-next-pages/probabilistic-idr/gcs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/probabilistic-idr/gcs"])
      });
    }
  